import resolve from '../../../../../modules/api/resolve';
import { apiPost, generateFormData } from '../../../../../modules/apiHelper';

export default {
  async getCompanyProgramTasksBadges(context, [companyId, programId]) {
    const programGoals = await context.dispatch('getProgramGoals', {
      companyid: companyId,
      progid: programId,
    });

    const result = await resolve(apiPost('prog_task_badge_list', generateFormData({ companyid: companyId, progid: programId }), 86))
      .then((res) => {
        if (!res) return false;

        const programGoalsBadges = res.prog_task_badge_list.map((goalBadge) => {
          // eslint-disable-next-line no-param-reassign
          goalBadge.goal = programGoals.find((goal) => Number(goal.id) === Number(goalBadge.goalid)) || {};

          return goalBadge;
        });

        return programGoalsBadges;
      });
    //

    return result;
  },

  async createProgramTaskBadge(context, data) {
    const formData = generateFormData({
      badge_name: data.name,
      desc: data.description,
      companyid: data.companyId,
      progid: data.programId,
      senderid: context.rootState.User.id,
    });
    formData.append('file1', data.badge);

    if (data.goalId) {
      formData.set('goalid', data.goalId);
    }

    const result = await resolve(apiPost('create_prog_task_badge', formData, 86));

    return result;
  },

  async deleteCompanyProgramTaskBadge(context, taskBadgeId) {
    const result = await resolve(apiPost('prog_del_task_badge', generateFormData({
      badgeid: taskBadgeId,
    }), 86));

    return !!result;
  },

  async getTaskBadge(context, taskId) {
    const result = await resolve(apiPost('prog_task_badge_tst_list', generateFormData({
      taskid: taskId,
    }), 86));

    if (result?.prog_task_badge_tst_list?.length) {
      return result.prog_task_badge_tst_list[0];
    }

    return {};
  },
};
